module.exports = __webpack_public_path__ + "static/media/mohren-logo.90606b4f.png";